<template>
    <ion-item class="ion-no-padding" @click="click($event)">
        <ion-item v-if="$root.isMobileOrSmall" class="start ion-no-padding ion-no-margin" slot="start">
            <ion-checkbox v-if="withCheckbox" color="primary" @ionChange="$emit('toggled', $event.target.checked)" ref="checkbox"></ion-checkbox>
        </ion-item>

        <ion-item v-else class="start ion-no-padding" slot="start">
            <ion-checkbox v-if="withCheckbox" color="primary" @ionChange="$emit('toggled', $event.target.checked)" ref="checkbox"></ion-checkbox>
            <file :file="file"></file>
        </ion-item>

        <file v-if="$root.isMobileOrSmall" :file="file"></file>
        <span v-else-if="withDate">{{ file.created_at }}</span>

        <span slot="end">
            <ion-icon v-if="canDelete"
                      class="delete"
                      ios="trash-sharp"
                      md="trash-sharp"
                      :title="$t('ncrypt.delete')"
                      @click="$emit('remove')"
                      button>
            </ion-icon>
        </span>
    </ion-item>
</template>

<script>
    import FilePopover from "../nav/FilePopover";
    import File from "../File";

    export default {
        name: "VaultFile",
        components: {File},
        props: {
            file: {type: Object},
            canDelete: {type: Boolean, default: false},
            withCheckbox: {type: Boolean, default: false},
            withDate: {type: Boolean, default: true},
        },
        methods: {
            click($event) {
                if (!this.withCheckbox || !$event.explicitOriginalTarget) {
                    return;
                }

                if ($event.explicitOriginalTarget.tagName === 'SPAN' || $event.explicitOriginalTarget.classList.contains('input-wrapper')) {
                    this.$refs.checkbox.click();
                }
            },
            async openFilePopover(event) {
                const popover = await this.$ionic.popoverController
                    .create({
                        component: FilePopover,
                        componentProps: {
                            parent: this,
                            propsData: {
                                attachment: this.attachment,
                            },
                        },
                        event,
                    });

                await popover.present();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .start {
        display: flex;
    }

    .delete {
        font-size: 18px;
        margin-left: 4px;
        position: relative;;
        top: -1px;
        color: #532222;
    }

    ion-checkbox {
        margin-right: 7px;

        button {
            width: auto;
        }
    }

    ion-chip {
        position: relative;
        z-index: 2;
    }

    ion-item {
        --background: transparent;
    }
</style>
